import {useIntl} from 'react-intl'
import {useEffect, useState} from 'react'
import {useContentfulClient} from './use-contentful-client.hook'
import {contentfulMediaFormatter, formatData} from '../../../utils'

export const useNewsLetter = () => {
    const {locale} = useIntl()
    const [data, setData] = useState(null)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const contentfulClient = useContentfulClient()

    useEffect(() => {
        contentfulClient
            .getEntries({
                locale,
                content_type: 'modal',
                'fields.modalType': 'Newsletter',
                include: 10,
                limit: 1
            })
            .then((response) => {
                const items = response?.items ?? []
                const newsletterModal = items?.at(-1)?.fields ?? null

                if (newsletterModal) {
                    const content = newsletterModal?.content?.fields
                    const contentFields = (content?.fields ?? []).map((field) =>
                        formatData(field)
                    )
                    setData({
                        ...newsletterModal,
                        content: {
                            ...content,
                            fields: contentFields,
                            submit: content?.submit?.fields,
                            afterSuccessLink: content?.afterSuccessLink?.fields
                        },
                        media: contentfulMediaFormatter(newsletterModal?.media)
                    })
                }
            })
            .catch((error) => setError(error))
            .finally(() => setIsLoading(false))
    }, [])

    return {isLoading, data, error}
}
